// extracted by mini-css-extract-plugin
export default {"imageWrapper":"tF-z","hovered":"uF-z","hoverImage":"vF-z","mainImage":"wF-z","imageNoBackground":"xF-z","fullSizeImage":"yF-z"};